<template>
  <div style="min-height: 100vh; position: relative">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            @click="filter = 'all'"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="filter = 'facebook'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="filter = 'line'"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              outline
              v-tooltip.top="'Unlock to PREMIUM plan'"
              color="grey"
              class="ma-0 mb-1"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              color="grey"
              outline
              class="ma-0 mb-1"
              @click="exportDashboard"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
      <date-filter
        v-model="selectedDate"
        defaultFilter="today"
        style="margin-bottom: 100px"
      ></date-filter>
      <v-flex xs12 sm12 md12 v-if="series.length != 0">
        <apexchart
          ref="satisfication"
          type="donut"
          height="500"
          :options="options"
          :series="series"
          :key="checkGraph"
          style="margin-bottom: 100px"
        ></apexchart>
      </v-flex>
      <v-flex xs12 sm12 md12 class="text-sm-center" v-else>
        <v-card :dark="true">{{ $t('No Data') }}</v-card>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DateFilter from '../../dashboard/DateFilter.vue'
import VueApexCharts from 'vue-apexcharts'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  components: {
    DateFilter,
    apexchart: VueApexCharts
  },
  computed: {
    loading: function () {
      return this.loadingActiveUserByDate && this.loadingActiveUserByTime
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data: function () {
    return {
      filter: 'all',
      checkGraph: Math.random(),
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      labels: ['น้อยที่สุด', 'น้อย', 'ปานกลาง', 'มาก', 'มากที่สุด'],
      checkResult: 1,
      options: {
        legend: {
          position: 'right',
          horizontalAlign: 'center',
          width: 180,
          height: 230,
          offsetY: 20,
          floating: true,
          fontSize: '16px',
          fontFamily: 'Helvetica, Arial'
        },
        chart: {
          width: '100%',
          type: 'donut'
        },
        labels: ['น้อยที่สุด', 'น้อย', 'ปานกลาง', 'มาก', 'มากที่สุด']
      },
      series: []
    }
  },
  mounted() {
    this.getScore()
  },
  methods: {
    getScore: function () {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        datefrom: vm.selectedDate.start,
        dateto: vm.selectedDate.end,
        // datefrom: '2021-12-08',
        // dateto: '2021-12-08',
        app: vm.filter
      }

      api['getSatisScore'](data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$emit('onLoaded', { loading: false, data: null })
          return
        }
        let data = []

        if (response.data.length > 0) {
          data = response.data.map((el) => {
            return parseInt(el.count)
          })

          vm.series = data
          vm.checkGraph = Math.random()
        } else {
          vm.series = data
        }
      })
    },
    exportDashboard: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      let json = []
      json.push([
        `${this.$t('from')} ` +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          moment(vm.selectedDate.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Customer Satisfaction')])
      json.push([this.$t('ระดับคะแนน'), this.$t('จำนวน')])

      $.each(vm.labels, function (index, label) {
        json.push([label, vm.series[index]])
      })

      const wb = XLSX.utils.book_new()
      let filename = ''
      if (
        moment(vm.selectedDate.start).format('DD/MM/YYYY') !=
        moment(vm.selectedDate.end).format('DD/MM/YYYY')
      ) {
        filename +=
          'cottodata-customer-satisfaction ' +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          '-' +
          moment(vm.selectedDate.end).format('DD/MM/YYYY') +
          '.xlsx'
      } else {
        filename +=
          'cottodata-customer-satisfaction ' +
          moment(vm.selectedDate.start).format('DD/MM/YYYY') +
          '.xlsx'
      }
      const dataWS1 = XLSX.utils.json_to_sheet(json)
      XLSX.utils.book_append_sheet(wb, dataWS1, 'Customer Satisfaction')
      XLSX.writeFile(wb, filename)
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getScore()
      },
      deep: true
    },
    filter: function () {
      this.getScore()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/CustomerSatisfaction.vue